import React, { useContext } from 'react';
import UserContext from '@components/context/userContext';

/**
 * TestEnvironmentAlert component
 * Displays a prominent warning when user is in test environment (memberType === 9)
 * Uses UserContext to get memberType automatically
 */
const TestEnvironmentAlert = () => {
  const profile = useContext(UserContext);

  if (profile.memberType !== 9) {
    return null;
  }

  return (
    <div 
      className="alert alert-warning" 
      style={{
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '20px',
        margin: '20px auto',
        maxWidth: '800px',
        border: '3px solid #f0ad4e',
        backgroundColor: '#fcf8e3',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
      }}
    >
      <i 
        className="fas fa-exclamation-triangle" 
        style={{ 
          fontSize: '24px', 
          marginRight: '10px', 
          color: '#f0ad4e' 
        }}
      ></i>
      ATENÇÃO: Está num ambiente de teste!
    </div>
  );
};

export default TestEnvironmentAlert;

